import Axios from "./caller.service";

let postContact = (formValue) => {

    return Axios.post('api/contacts', formValue)
}

export const contactService = {
    postContact
}